const isEmptyValue = (value) =>
  value === null || value === undefined || value === "";

export const toShowroomId = (value) => {
  const asNumber = Number(value);
  return Number.isFinite(asNumber) ? asNumber : value;
};

export const toShowroomIdList = (value) => {
  if (isEmptyValue(value)) return [];
  const list = Array.isArray(value) ? value : [value];
  return list.filter((item) => !isEmptyValue(item)).map(toShowroomId);
};

export const hasShowroom = (value, showroomId) =>
  toShowroomIdList(value).some((id) => String(id) === String(showroomId));

export const buildSelectedShowrooms = (ids, options, fallbackName) => {
  const idList = toShowroomIdList(ids);
  return idList.map((id) => {
    const match = (options || []).find(
      (option) => String(option.id) === String(id),
    );
    if (match) return match;
    if (idList.length === 1 && fallbackName) {
      return { label: fallbackName, value: fallbackName, id };
    }
    return { label: String(id), value: String(id), id, unknownName: true };
  });
};

export const getSelectedShowroomIds = (selected) =>
  (selected || []).map((item) => toShowroomId(item.id));

export const getSelectedShowroomNames = (selected) =>
  (selected || [])
    .filter((item) => !item.unknownName)
    .map((item) => item.value)
    .join(", ");

export const hasSameShowroomIds = (selected, originalIds) => {
  const current = getSelectedShowroomIds(selected).map(String).sort();
  const original = toShowroomIdList(originalIds).map(String).sort();
  return (
    current.length === original.length &&
    current.every((id, index) => id === original[index])
  );
};
